import * as React from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import styles from './switchtodooer.module.scss'
import Button from '../../../../components/button'

export default function Switchtodooer() {
  return (
    <div className={styles.switchToDooer}>
      <FormattedHTMLMessage
        defaultMessage="Flytta bokföringen till Dooer"
        id="landingPage.switchtodooer.heading"
        tagName="h2"
      />

      <FormattedHTMLMessage
        defaultMessage="Det är enkelt att byta från ditt nuvarande program och förenkla din bokföring med Dooer."
        id="landingPage.switchtodooer.description"
        tagName="p"
      />

      <div className={styles.buttonWrapper}>
        <Button href="/hjalp/komigang" variant="success">
          <FormattedHTMLMessage
            defaultMessage="Jag vill veta mer"
            id="landingPage.switchtodooer.button"
            tagName="span"
          />
        </Button>
      </div>
    </div>
  )
}
